<template>
  <div
    :class="[isModalOpen ? 'd-flex' : 'd-none']"
    class="custom-size-modal size-modal image-modal-wrapper generic-modal position-fixed align-items-center justify-content-center">
    <div class="modal-inner align-items-center justify-content-center d-flex h-100 w-100">
      <div
        class="bm-modal-content custom-size-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="custom-size-title">
        <div class="cs-header">
          <div class="cs-heading">
            <h2 id="custom-size-title">Add Custom Size</h2>
            <p>Saved sizes appear under Favorites in Common sizes.</p>
          </div>
          <button
            type="button"
            class="cs-close"
            aria-label="Close"
            title="Close"
            @click="handleModalClose">
            <icon name="close-icon"/>
          </button>
        </div>

        <div class="cs-body">
          <div
            v-show="!isValidInput.every(Boolean)"
            class="cs-alert"
            role="alert">
            <span class="cs-alert-icon">
              <icon name="alert-circle"/>
            </span>
            <ul>
              <li
                v-for="(item, index) in activeErrors"
                :key="index">{{ item }}</li>
            </ul>
          </div>

          <div class="cs-field">
            <label for="size-name">Size Name</label>
            <div
              class="cs-control"
              :class="{ 'is-invalid': !isValidInput[2] }">
              <input
                id="size-name"
                v-model="title"
                type="text"
                placeholder="Enter title for this size"
                :aria-invalid="String(!isValidInput[2])">
            </div>
          </div>

          <div class="cs-grid">
            <div class="cs-field">
              <label for="size-width">Width</label>
              <div
                class="cs-control"
                :class="{ 'is-invalid': !isValidInput[1] }">
                <input
                  id="size-width"
                  v-model="width"
                  type="number"
                  class="cs-mono"
                  :aria-invalid="String(!isValidInput[1])">
              </div>
              <div
                v-show="!isValidInput[1]"
                class="cs-hint">
                <icon name="alert-circle"/>
                {{ rangeHint }}
              </div>
            </div>
            <div class="cs-field">
              <label for="size-height">Height</label>
              <div
                class="cs-control"
                :class="{ 'is-invalid': !isValidInput[0] }">
                <input
                  id="size-height"
                  v-model="height"
                  type="number"
                  class="cs-mono"
                  :aria-invalid="String(!isValidInput[0])">
              </div>
              <div
                v-show="!isValidInput[0]"
                class="cs-hint">
                <icon name="alert-circle"/>
                {{ rangeHint }}
              </div>
            </div>
            <div class="cs-field">
              <label
                id="size-unit-label"
                for="size-unit">Unit</label>
              <div
                ref="unitField"
                class="cs-unit">
                <button
                  id="size-unit"
                  type="button"
                  class="cs-control cs-unit-btn"
                  aria-haspopup="listbox"
                  :aria-expanded="unitMenuOpen ? 'true' : 'false'"
                  @click="toggleUnitMenu">
                  <span class="cs-unit-value">{{ unit }}</span>
                  <span
                    class="cs-chevron"
                    :class="{ 'is-open': unitMenuOpen }">
                    <icon name="chevron"/>
                  </span>
                </button>
                <ul
                  v-show="unitMenuOpen"
                  class="cs-unit-menu"
                  role="listbox"
                  aria-labelledby="size-unit-label">
                  <li
                    v-for="option in unitOptions"
                    :key="option"
                    role="option"
                    :aria-selected="unit === option ? 'true' : 'false'"
                    :class="{ 'is-selected': unit === option }"
                    @click="selectUnit(option)">
                    {{ option }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="cs-footer">
          <button
            type="button"
            class="cs-btn cs-btn-cancel"
            @click="handleModalClose">Cancel</button>
          <button
            type="button"
            class="cs-btn cs-btn-save"
            @click.stop="addFavouriteSize">Save</button>
        </div>
      </div>
    </div>
    <div
      class="backdrop position-fixed h-100 w-100"
      @click="handleModalClose"
    />
  </div>
</template>
<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  data() {
    return {
      isModalOpen:  false,
      width:        0,
      height:       0,
      unit:         'px',
      title:        'custom-size',
      message:      ['Height should be a greater than 0.14 inch/ 10 pixels and less than 100 inches / 7200px ', 'Width should be a greater than 0.14 inch/ 10 pixels and less than 100 inches / 7200px', 'Length of title must be greater than 3 and less than 20'],
      isValidInput: [true, true, true],
      unitMenuOpen: false,
      unitOptions:  ['Pixels', 'Inches'],
    };
  },
  computed: {
    activeErrors() {
      return this.message.filter((item, index) => !this.isValidInput[index]);
    },
    rangeHint() {
      return this.unit === 'Inches' ? '0.14–100 in' : '10–7200 px';
    },
  },
  mounted() {
    EventBus.$on(ApplicationEventTypes.ModalEvents.SHOW_SIZE_MODAL, this.showModal);
    document.addEventListener('click', this.closeUnitMenuOnOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeUnitMenuOnOutsideClick);
  },


  methods: {

    toggleUnitMenu() {
      this.unitMenuOpen = !this.unitMenuOpen;
    },
    selectUnit(option) {
      this.unit         = option;
      this.unitMenuOpen = false;
    },
    closeUnitMenuOnOutsideClick(event) {
      if (!this.unitMenuOpen || !this.$refs.unitField) return;
      if (!this.$refs.unitField.contains(event.target)) {
        this.unitMenuOpen = false;
      }
    },
    handleModalClose() {
      this.$store.commit('setSizeModel', false);
      this.unitMenuOpen = false;
      this.isModalOpen = !this.isModalOpen;
    },
    showModal(temData) {
      this.isModalOpen  = true;
      this.unitMenuOpen = false;
      this.isValidInput = [true, true, true];
      this.width        = temData.width;
      this.height       = temData.height;
      this.unit         = temData.unit;
    },
    validateInput() {
      const isWidthNumeric  = /^-?[0-9]+(?:\.[0-9]+)?$/.test(this.width) && ((this.unit == 'Inches' && this.width >= 0.14 && this.width <= 100) || (this.unit == 'Pixels' && this.width >= 10 && this.width <= 7200));
      const isHeightNumeric = /^-?[0-9]+(?:\.[0-9]+)?$/.test(this.height) && ((this.unit == 'Inches' && this.height >= 0.14 && this.height <= 100) || (this.unit == 'Pixels' && this.height >= 10 && this.height <= 7200));
      const isTitleValid    = this.title.length > 3 && this.title.length < 20;
      return {
        isValid:       isHeightNumeric && isWidthNumeric && isTitleValid,
        messageToShow: [isHeightNumeric, isWidthNumeric, isTitleValid],
      };
    },
    addFavouriteSize() {
      const validationResult = this.validateInput();
      this.isValidInput      = [true, true, true];
      if (!validationResult.isValid) {
        this.isValidInput =  validationResult.messageToShow;
        return;
      }
      const userId    = this.$store.getters.getUserId;
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=AddUserFavoriteSize&domainURL=https://${domainUrl}.com/&userId=${userId}&name=${this.title}&width=${this.width}&height=${this.height}&unit=${this.unit}`;

      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', (Response) => {
        const parser            = new DOMParser();
        const xmlParsed         = parser.parseFromString(Response.target.response, 'text/xml');
        let favouriteSizeResult = xmlParsed.getElementsByTagName('AddUserFavoriteSizeResult');
        favouriteSizeResult[0] && (favouriteSizeResult = favouriteSizeResult[0].innerHTML);
        const parse = JSON.parse(favouriteSizeResult);
        this.$store.commit('updateFavouriteSizes', parse);
        this.isModalOpen = false;
      });
      oReq.addEventListener('error', (e) => {
        console.error(e);
        this.isModalOpen = false;
      });
      oReq.open('GET', url);
      oReq.send();
    },
  },
};

</script>
<style lang="scss">
.custom-size-modal.image-modal-wrapper {
  .bm-modal-content.custom-size-dialog {
    width: 480px !important;
    min-width: 0 !important;
    max-width: calc(100vw - 32px) !important;
    height: auto !important;
    max-height: none !important;
    padding: 0;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 0 0 1px rgba(16, 24, 40, 0.06), 0 24px 64px rgba(16, 24, 40, 0.28);
    overflow: visible;
    display: flex;
    flex-direction: column;
    z-index: 2;
    font-family: 'Geist', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif;
    color: #14161B;
    -webkit-font-smoothing: antialiased;
  }

  .cs-header {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 20px 20px 0 24px;
  }

  .cs-heading {
    flex: 1 1 auto;
    min-width: 0;
  }

  h2 {
    margin: 0;
    font-family: inherit;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1.3;
    color: #14161B;
  }

  .cs-heading p {
    margin: 0 !important;
    padding-top: 4px;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.45;
    color: #5E6573;
  }

  .cs-close {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 8px;
    padding: 0;
    cursor: pointer;
    background: transparent;
    color: #3D4350;
  }

  .cs-close:hover {
    background: #F3F4F6;
  }

  .cs-body {
    padding: 20px 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .cs-alert {
    display: flex;
    gap: 10px;
    padding: 11px 12px;
    border-radius: 10px;
    background: #FEF3F2;
    box-shadow: inset 0 0 0 1px #FBC9C4;
  }

  .cs-alert-icon {
    color: #D92D20;
    padding-top: 1px;
    flex-shrink: 0;
  }

  .cs-alert ul {
    margin: 0;
    padding: 0 0 0 14px;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .cs-alert li {
    font-size: 12.5px;
    font-weight: 400;
    line-height: 1.45;
    color: #912018;
  }

  .cs-field {
    min-width: 0;
  }

  .cs-field label {
    display: block;
    margin: 0 0 6px;
    font-family: inherit;
    font-size: 12.5px;
    font-weight: 600;
    line-height: 1.3;
    color: #3D4350;
  }

  .cs-control {
    height: 38px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 12px;
    background: #fff;
    border-radius: 9px;
    box-sizing: border-box;
    box-shadow: inset 0 0 0 1px #E7E9ED;
  }

  .cs-control.is-invalid {
    box-shadow: inset 0 0 0 1.5px #D92D20;
  }

  .cs-control input {
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
    height: 100%;
    border: 0;
    outline: 0;
    background: transparent;
    padding: 0;
    margin: 0;
    font-family: inherit;
    font-size: 13.5px;
    font-weight: 400;
    color: #14161B;
    box-shadow: none;
  }

  .cs-control input:focus,
  .cs-unit-btn:focus,
  .cs-close:focus,
  .cs-btn:focus {
    outline: none;
    border: 0;
  }

  .cs-control input.cs-mono {
    font-family: 'Geist Mono', ui-monospace, 'SF Mono', Menlo, monospace;
  }

  .cs-unit {
    position: relative;
    z-index: 3;
  }

  .cs-unit-btn {
    width: 100%;
    border: 0;
    cursor: pointer;
    font-family: inherit;
    font-size: 13.5px;
    font-weight: 400;
    color: #14161B;
    text-align: left;
  }

  .cs-unit-value {
    flex: 1 1 auto;
    min-width: 0;
  }

  .cs-unit-menu {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 4;
    margin: 0;
    padding: 4px;
    list-style: none;
    background: #fff;
    border-radius: 9px;
    box-shadow: 0 0 0 1px rgba(16, 24, 40, 0.06), 0 12px 32px rgba(20, 22, 27, 0.12);
  }

  .cs-unit-menu li {
    padding: 8px 10px;
    border-radius: 6px;
    font-size: 13.5px;
    line-height: 1.3;
    color: #14161B;
    cursor: pointer;
  }

  .cs-unit-menu li:hover,
  .cs-unit-menu li.is-selected {
    background: #F3F4F6;
  }

  .cs-unit-menu li.is-selected {
    background: #EAF2FE;
  }

  .cs-chevron {
    color: #5E6573;
    display: flex;
    flex-shrink: 0;
  }

  .cs-chevron svg {
    transition: transform 0.15s ease;
  }

  .cs-chevron.is-open svg {
    transform: rotate(180deg);
  }

  .cs-close .icon,
  .cs-alert-icon .icon,
  .cs-hint .icon,
  .cs-chevron .icon {
    min-width: 0;
    min-height: 0;
  }

  .cs-close .icon svg,
  .cs-alert-icon .icon svg {
    width: 16px;
    height: 16px;
  }

  .cs-hint .icon svg {
    width: 13px;
    height: 13px;
  }

  .cs-chevron .icon svg {
    width: 15px;
    height: 15px;
  }

  .cs-hint {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 6px;
    font-size: 12px;
    line-height: 1.3;
    color: #D92D20;
  }

  .cs-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
  }

  .cs-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    padding: 14px 24px;
    border-top: 1px solid #E7E9ED;
    background: #FBFBFC;
    border-radius: 0 0 16px 16px;
  }

  .cs-btn {
    height: 38px;
    min-height: 38px;
    min-width: 72px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 0 14px;
    border: 0;
    border-radius: 9px;
    font-family: inherit;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
  }

  .cs-btn-cancel {
    background: #fff;
    color: #14161B;
    box-shadow: inset 0 0 0 1px #D5D9E0;
  }

  .cs-btn-cancel:hover {
    background: #F3F4F6;
  }

  .cs-btn-save {
    background: #1570EF;
    color: #fff;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.12);
  }

  .cs-btn-save:hover {
    background: #0B57C2;
  }
}
</style>
